import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import { OrderModel } from "../../models/orders/order-list-model";
import Helpers from "../../utils/helpers";
import '../../assests/css/common/responsive-ui.css'


interface SelectInvoiceProps {
  orderData: OrderModel;
  updatePaymentInvoiceId: (invoiceId: number) => void;
}

const SelectPaymentInvoice: React.FC<SelectInvoiceProps> = ({ orderData, updatePaymentInvoiceId }) => {
  
  const { t } = useTranslation();
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<number>(orderData.orderInvoice[0].invoiceNo);
  const [selectedInvoiceAmount, setSelectedInvoiceAmount] = useState<number>(orderData.orderInvoice[0].grossAmount);
  const invoiceList: any = orderData.orderInvoice.map((invoice)=> ({
    invoiceNo: invoice.invoiceNo,
    amount: invoice.grossAmount
  }));

  useEffect(() => {
    updatePaymentInvoiceId(selectedInvoiceId); 
  }, []);

  return (
    <>      
      <div className="flex flex-wrap gap-3">
        <span className="mt-2">Select Invoice# : </span> 
        <Dropdown
            id="invoiceNo"
            name="invoiceNo"
            options={invoiceList}
            optionLabel="invoiceNo"
            optionValue="invoiceNo"
            value={selectedInvoiceId}
            onChange={(e) => {
              setSelectedInvoiceId(e.target.value);
              updatePaymentInvoiceId(e.target.value);
              invoiceList.map((invoice: any)=>{
                if(invoice.invoiceNo == e.target.value) {
                  setSelectedInvoiceAmount(invoice.amount);
                }                  
              });
            }}
            placeholder="Select Invoice No" style={{ width: 150 }}
        />
        <span className="responsive-amount">Amount: <span style={{color:"green"}}>{Helpers.formatAmountInINR(selectedInvoiceAmount)}</span></span>
      </div>          
    </>
  )
}

export default SelectPaymentInvoice;